import type {
  CosimaRoot,
  EditionDetails,
  LanguageCode,
  LanguageVariant,
  PkBenefits,
  PkDescription,
  PkFunctions,
  PkMeta,
  PkNotes,
  PkShortDescription,
  PkTechData,
} from './document'

export type CosimaComponents = 'PK-meta' | 'PK-techdata' | 'PK-short-description' | 'PK-benefits' | 'PK-description'

export interface EnhancedCosimaRoot {
  // xml properties
  id: string
  version: number
  /** ISO 639-1 language code */
  language: LanguageCode
  /** ISO 639-1 language code */
  variant: LanguageVariant
  /** "Edition"? */
  format: string

  details: {
    editionDetails: EditionDetails
    meta?: PkMeta
    shortDescription?: PkShortDescription
    description?: PkDescription
    benefits?: PkBenefits
    techdata?: PkTechData
    notes?: PkNotes
    functions?: PkFunctions
  }
}

export const enhanceCosimaRoot = (root: CosimaRoot): EnhancedCosimaRoot => {
  const meta = root.nodes['PK-meta']
  const techdata = root.nodes['PK-techdata']
  const shortDescription = root.nodes['PK-short-description']
  const benefits = root.nodes['PK-benefits']
  const description = root.nodes['PK-description']
  const notes = root.nodes['PK-notes']
  const functions = root.nodes['PK-functions']

  return {
    id: root.id,
    version: root.version,
    language: root.language,
    variant: root.variant,
    format: root.format,

    details: {
      editionDetails: root.editionDetails,
      meta: meta as PkMeta | undefined,
      shortDescription: shortDescription as PkShortDescription | undefined,
      description: description as PkDescription | undefined,
      benefits: benefits as PkBenefits | undefined,
      techdata: techdata as PkTechData | undefined,
      notes: notes as PkNotes | undefined,
      functions: functions as PkFunctions | undefined,
    },
  }
}

export const getCosimaImages = (cosima?: EnhancedCosimaRoot) => {
  const images: { type: 'image'; id: string; url: `/cosima/${string}`; alt: string }[] = []

  for (const image of cosima?.details.meta?.figure.images ?? []) {
    images.push({
      type: 'image',
      id: image.id,
      url: `/cosima/${image.fileName}`,
      alt: image.name,
    })
  }

  for (const figure of cosima?.details.techdata?.figure ?? []) {
    for (const image of figure.images) {
      images.push({
        type: 'image',
        id: image.id,
        url: `/cosima/${image.fileName}`,
        alt: image.name,
      })
    }
  }

  return images
}
